var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reports"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    clipPath: "url(#clip-Reports)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34460",
    "data-name": "Group 34460",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34459",
    "data-name": "Group 34459",
    transform: "translate(2.569 5.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_777",
    "data-name": "Vector 777",
    d: "M0,0H5.3",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_778",
    "data-name": "Vector 778",
    d: "M0,0H3.973",
    transform: "translate(0 3.973)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    d: "M7.465,0h2.969V12.282H0V0H2.976",
    transform: "translate(0 0.96)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    width: 4.482,
    height: 1.921,
    rx: 0.96,
    transform: "translate(2.976)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    "data-name": "Rectangle 1688",
    width: 16,
    height: 16,
    transform: "translate(-2)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.1f2910f1f04e4e53aceb842eb51fc736.svg";
export { ForwardRef as ReactComponent };